import { call, put, takeLatest, all } from 'redux-saga/effects';
import * as types from './actionTypes';
import Swal from 'sweetalert2';
import { post } from 'helpers/api_helper';

function* fetchTimesheetReportDropdownsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_REPORT_DROPDOWNS, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch dropdowns');
    yield put({ type: types.FETCH_TIMESHEET_REPORT_DROPDOWNS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_REPORT_DROPDOWNS_FAILURE, payload: error.message });
  }
}

// Report List
function* fetchTimesheetReportListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_REPORT_LIST, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch report list');
    yield put({ type: types.FETCH_TIMESHEET_REPORT_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_REPORT_LIST_FAILURE, payload: error.message });
  }
}

function* fetchTimesheetTaskStatusReportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_TASK_STATUS_REPORT_LIST, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch task status report');
    yield put({ type: types.FETCH_TIMESHEET_TASK_STATUS_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_TASK_STATUS_REPORT_FAILURE, payload: error.message });
  }
}

function* fetchTimesheetEmployeeTaskStatusReportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_LIST, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch employee task status report');
    yield put({ type: types.FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_FAILURE, payload: error.message });
  }
}

// Project Status Report Saga
function* fetchProjectStatusReportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_STATUS_REPORT, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch project status report');
    yield put({ type: types.FETCH_PROJECT_STATUS_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_PROJECT_STATUS_REPORT_FAILURE, payload: error.message });
  }
}

// Project Details Report Saga
function* fetchProjectDetailsReportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_PROJECTDETAILS_REPORT, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch project details report');
    yield put({ type: types.FETCH_PROJECT_DETAILS_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_PROJECT_DETAILS_REPORT_FAILURE, payload: error.message });
  }
}

// Project Service Report Saga
function* fetchProjectServiceReportSaga(action) {
  try {
    console.log('Project Service Report URL:', process.env.REACT_APP_FETCH_TIMESHEET_PROJECTSERVICE_REPORT);
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_PROJECTSERVICE_REPORT, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch project service report');
    yield put({ type: types.FETCH_PROJECT_SERVICE_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_PROJECT_SERVICE_REPORT_FAILURE, payload: error.message });
  }
}

// Module Tasks Report Saga
function* fetchModuleTasksReportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_MODULE_TASKS_REPORT, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch module tasks report');
    yield put({ type: types.FETCH_MODULE_TASKS_REPORT_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: types.FETCH_MODULE_TASKS_REPORT_FAILURE, payload: error.message });
  }
}

// Employee Details Report Saga
function* fetchEmployeeDetailsReportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_EMPLOYEE_DETAILS_REPORT, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch employee details report');
    yield put({ type: types.FETCH_EMPLOYEE_DETAILS_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_EMPLOYEE_DETAILS_REPORT_FAILURE, payload: error.message });
  }
}

// Module Search Report Saga
function* fetchModuleSearchReportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_TIMESHEET_MODULESEARCH, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch module search report');
    yield put({ type: types.FETCH_MODULE_SEARCH_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_MODULE_SEARCH_REPORT_FAILURE, payload: error.message });
  }
}

// Project Status List Saga
function* fetchProjectStatusListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_TIMESHEET_GETSTATUSLIST, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch project status list');
    yield put({ type: types.FETCH_PROJECT_STATUS_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_PROJECT_STATUS_LIST_FAILURE, payload: error.message });
  }
}

// Project Client Details List Saga
function* fetchProjectClientDetailsListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_TIMESHEET_GETEMPLIST, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch project client details list');
    yield put({ type: types.FETCH_PROJECT_CLIENT_DETAILS_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_PROJECT_CLIENT_DETAILS_LIST_FAILURE, payload: error.message });
  }
}

// Project Employee Details Saga
function* fetchProjectEmployeeDetailsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_TIMESHEET_GETEMPDETAILS, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch project employee details');
    yield put({ type: types.FETCH_PROJECT_EMPLOYEE_DETAILS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_PROJECT_EMPLOYEE_DETAILS_FAILURE, payload: error.message });
  }
}

// Project Client List Saga
function* fetchProjectClientListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_TIMESHEET_CLIENTLIST, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch project client list');
    yield put({ type: types.FETCH_PROJECT_CLIENT_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_PROJECT_CLIENT_LIST_FAILURE, payload: error.message });
  }
}

function* fetchTimesheetMonthlyReportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_MONTH_LIST, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Failed to fetch monthly report');
    yield put({ type: types.FETCH_TIMESHEET_MONTHLY_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_MONTHLY_REPORT_FAILURE, payload: error.message });
  }
}

function* fetchProjecstatusexportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_TIMESHEET_PROJECTSTATUS_EXPORT, action.payload);

    if (!response || response.status !== "success") { throw new Error(response?.message || "Failed to download template!"); }
    // ✅ Trigger file download
    if (response?.data) {
      const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${response.data}`; // full URL
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "EmployeePunchTemplate.xlsx"; // optional filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    Swal.fire("Success", "Template downloaded successfully!", "success");
    yield put({ type: types.FETCH_PROJECT_STATUS_EXPORT_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.FETCH_PROJECT_STATUS_EXPORT_FAILURE, payload: error });
  }
}

// Watcher
export default function* timesheetSaga() {
  yield takeLatest(types.FETCH_TIMESHEET_REPORT_DROPDOWNS_REQUEST, fetchTimesheetReportDropdownsSaga);
  yield takeLatest(types.FETCH_TIMESHEET_REPORT_LIST_REQUEST, fetchTimesheetReportListSaga);
  yield takeLatest(types.FETCH_TIMESHEET_TASK_STATUS_REPORT_REQUEST, fetchTimesheetTaskStatusReportSaga);
  yield takeLatest(types.FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_REQUEST, fetchTimesheetEmployeeTaskStatusReportSaga);
  yield takeLatest(types.FETCH_TIMESHEET_MONTHLY_REPORT_REQUEST, fetchTimesheetMonthlyReportSaga);
  yield takeLatest(types.FETCH_PROJECT_STATUS_REPORT_REQUEST, fetchProjectStatusReportSaga);
  yield takeLatest(types.FETCH_PROJECT_DETAILS_REPORT_REQUEST, fetchProjectDetailsReportSaga);
  yield takeLatest(types.FETCH_PROJECT_SERVICE_REPORT_REQUEST, fetchProjectServiceReportSaga);
  yield takeLatest(types.FETCH_MODULE_TASKS_REPORT_REQUEST, fetchModuleTasksReportSaga);
  yield takeLatest(types.FETCH_EMPLOYEE_DETAILS_REPORT_REQUEST, fetchEmployeeDetailsReportSaga);
  yield takeLatest(types.FETCH_MODULE_SEARCH_REPORT_REQUEST, fetchModuleSearchReportSaga);
  yield takeLatest(types.FETCH_PROJECT_STATUS_LIST_REQUEST, fetchProjectStatusListSaga);
  yield takeLatest(types.FETCH_PROJECT_CLIENT_DETAILS_LIST_REQUEST, fetchProjectClientDetailsListSaga);
  yield takeLatest(types.FETCH_PROJECT_EMPLOYEE_DETAILS_REQUEST, fetchProjectEmployeeDetailsSaga);
  yield takeLatest(types.FETCH_PROJECT_CLIENT_LIST_REQUEST, fetchProjectClientListSaga);
  yield takeLatest(types.FETCH_PROJECT_STATUS_EXPORT_REQUEST, fetchProjecstatusexportSaga);
}
